import React, {FC, useEffect} from 'react'
import {useFormContext, Controller} from 'react-hook-form'
import {FilterRegex} from '../../../util/functions'

type InputProps = {
  type?: string
  name: string
  textPlaceholder?: string
  maxLength?: number
  minLength?: number
  disabled?: boolean | undefined
}

const InputNumber: FC<InputProps> = ({
  type = 'numeric',
  name,
  textPlaceholder,
  maxLength = 9999,
  minLength = 0,
  disabled = false,
  ...props
}) => {
  const {
    control,
    formState: {errors},
    setValue,
    watch,
  } = useFormContext()
  const value = watch(name) ?? ''

  useEffect(() => {
    if (value === undefined) {
      setValue(name, '')
    }
  }, [value, setValue, name])

  let regex = FilterRegex(type)

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: {onChange: (value: string) => void},
  ) => {
    let value = e.target.value.replace(/\s+/g, '')
    if (!regex.test(value)) {
      return
    }
    value = value.toUpperCase()
    field.onChange(value)
  }
  return (
    <div className='sdx_form_input'>
      <Controller
        name={name}
        control={control}
        defaultValue={value}
        render={({field}) => (
          <input
            type='text'
            className='form-control sdx-centra-input-form'
            {...field}
            placeholder={textPlaceholder}
            maxLength={maxLength}
            minLength={minLength}
            disabled={disabled}
            onChange={(e) => handleChange(e, field)}
          />
        )}
      />

      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputNumber
